import React from 'react';
//import $ from 'jquery';
import _ from 'lodash';

export default class SizeGiver extends React.Component {
	constructor(props) {
		super(props);
		this.props=props;
        this.handleResize = this.handleResize.bind(this);
		this._handleResize = (_.throttle(this.handleResize,100)).bind(this);
		this.state = { 
			containerWidth: null,
            containerheight: null
		}
	}
	componentDidMount() {
		if(typeof window !== "undefined") {
			window.addEventListener('resize', this._handleResize);
			this.handleResize.bind(this)();
		}
	}
	componentWillUnmount() {
		if(typeof window !== "undefined") {
			window.removeEventListener('resize', this._handleResize);
		}
	}
	handleResize() {
        let computedWidth = window.getComputedStyle(this.refs.container).width;
        let computedHeight = window.getComputedStyle(this.refs.container).height;
        this.setState({	
            containerWidth: computedWidth? parseFloat(computedWidth) : null,
            containerHeight: computedHeight? parseFloat(computedHeight) : null
        });
	}
	getChildContext() {
        let retobj = {};
        if(this.state.containerWidth) {
            retobj.containerWidth = this.state.containerWidth;
        }
        if(this.state.containerHeight) {
            retobj.containerHeight = this.state.containerHeight;    
        }                
        return retobj;
	}
	
	render() {
		return (
			<div style={{width:"100%"}} ref="container">{this.props.children}</div>
		);
	}
}

SizeGiver.childContextTypes = {
	containerWidth: React.PropTypes.number,
    containerHeight: React.PropTypes.number
}


// WEBPACK FOOTER //
// ./src/js/containers/SizeGiver/SizeGiver.jsx